
import { logger } from "@/services/LoggingService";
import { toast } from "sonner";
import { 
  IMAGE_PATHS, 
  FILE_NAMES,
  validateImageFile,
  uploadStorageFile,
  StorageError 
} from '@/utils/image-storage';

const COMPONENT = 'FileUploadHandler';

interface FileUploadProps {
  companyId: string;
  file: File;
  onSuccess: (publicUrl: string) => Promise<void>;
  setIsUploading: (isUploading: boolean) => void;
}

export async function handleFileUpload({
  companyId,
  file,
  onSuccess,
  setIsUploading
}: FileUploadProps): Promise<boolean> {
  if (!file) {
    toast.error("No file selected");
    return false;
  }

  try {
    logger.info(COMPONENT, 'Starting file upload', {
      companyId,
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size
    });

    setIsUploading(true);
    validateImageFile(file);
    
    const publicUrl = await uploadStorageFile(
      IMAGE_PATHS.COMPANY(companyId),
      FILE_NAMES.COMPANY_LOGO,
      file,
      { upsert: true }
    );
    
    await onSuccess(publicUrl);
    
    logger.info(COMPONENT, 'File upload successful', {
      companyId,
      publicUrl
    });
    
    toast.success("Logo uploaded successfully");
    return true;
  } catch (error: any) {
    logger.error(COMPONENT, 'File upload failed', {
      error: error.message,
      details: error instanceof StorageError ? error.details : error
    });
    
    toast.error(error.message || "Failed to upload logo");
    return false;
  } finally {
    setIsUploading(false);
  }
}
